import { PlusIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Add = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <PlusIcon color={fill} {...rest} size={Sizes[size]} />;
};

Add.displayName = 'Add';
